/**
 * Shared base path for survey feedback API endpoints.
 */
export const SURVEY_API_BASE = 'https://custom-p0.feedbook.me/api/feedback/survey';
